var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#8fd2db",
    height: "247px",
    width: "247px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.125 511.125",
    xmlSpace: "preserve",
    stroke: "#8fd2db",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M489.792,360.46h-1.109c-5.205-37.824-29.995-64-62.891-64s-57.685,26.176-62.891,64h-1.109 c-11.776,0-21.333,9.557-21.333,21.333V488.46c0,11.776,9.557,21.333,21.333,21.333h128c11.797,0,21.333-9.557,21.333-21.333 V381.793C511.125,370.017,501.589,360.46,489.792,360.46z M425.792,339.126c10.432,0,16.832,9.536,19.648,21.333h-39.296 C408.96,348.662,415.36,339.126,425.792,339.126z M468.459,467.126h-85.333v-64h21.333v21.333 c0,11.776,9.557,21.333,21.333,21.333s21.333-9.557,21.333-21.333v-21.333h21.333V467.126z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.125,254.115c0-35.008,7.637-70.635,20.181-104.704c-26.539-9.771-51.904-22.955-75.392-39.851L52.032,97.571 C22.997,135.609,4.139,182.073,0,232.782v42.667c4.203,51.499,23.616,98.581,53.44,136.939l17.387-14.421 c24.064-16.981,49.664-30.123,76.245-39.744C134.677,324.323,127.125,288.91,127.125,254.115z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.125,126.115c16.491,0,32.789-1.685,48.789-4.629c-14.016-26.709-30.912-51.392-48.789-72.192 c-17.856,20.8-34.752,45.483-48.768,72.213C222.379,124.451,238.635,126.115,255.125,126.115z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.245,110.128c16.853-34.048,38.016-65.408,60.779-91.349c-1.6-1.387-3.2-2.901-4.8-4.203 c-4.203-3.477-6.549-8.256-7.317-13.248C162.581,9.136,117.056,31.92,81.109,65.349l14.293,8.619 C117.099,89.541,140.203,101.488,164.245,110.128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.168,76.406l13.333-10.667C389.067,34.038,345.12,11.702,296.907,2.828c-1.024,4.437-3.115,8.64-6.891,11.755 c-1.579,1.301-3.179,2.795-4.779,4.181c22.763,25.963,43.947,57.323,60.8,91.349C368.907,101.9,390.816,90.742,411.168,76.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.887,397.392c-23.595,8.256-46.187,19.691-67.136,34.432l-14.485,12.032c43.157,39.701,99.861,64.299,162.155,65.941 C214.362,480.507,185.498,441.253,163.887,397.392z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.159,386.316c19.541,37.397,44.757,70.784,70.293,95.168v-99.371h-23.659 C237.028,382.113,221.476,383.628,206.159,386.316z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.125,253.844c0,0.107-0.064,0.171-0.064,0.277h0.064v21.333h106.667c11.797,0,21.333-9.557,21.333-21.333 c0-58.859-21.547-113.728-56.981-157.504L436.8,110.506c-23.296,16.405-48.085,29.227-73.856,38.763 C375.467,183.316,383.125,218.9,383.125,253.844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.459,254.115h0.064c0-0.107-0.064-0.171-0.064-0.277c0-30.549-7.083-62.123-18.581-92.416 c-21.824,4.779-44.117,7.36-66.752,7.36c-22.656,0-44.971-2.581-66.731-7.339c-11.499,30.379-18.603,62.016-18.603,92.672 c0,30.528,7.04,62.016,18.453,92.267c21.141-4.48,42.688-6.933,64.555-6.933h23.659v-64h64V254.115z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService1);
export default __webpack_public_path__ + "static/media/service-1.6bfd30ebd201c0e0f07c37ca2bce37f2.svg";
export { ForwardRef as ReactComponent };